export const warningPopoverContent =
  'Are you sure you want to delete this interaction? This action cannot be undone.'

export const remoteInteractionWarningPopoverContent =
  'Are you sure you want to delete this interaction? Any delivered but incomplete interactions will be also be removed. This action cannot be undone.'
